// ----------------------------------------------------------------------
// <copyright file="Izenda.SimpleGauge.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------


/**
 * @module KPIMetricChart
 * @description HighCharts extension for KPI Metric tiles that extends the extension of Simple Gauges
 */
!(function () {
  const { constant, get, times } = require('lodash/fp');
  module.exports = function (H) {

    var MAX_CHARS = 10;
    var TEXT_COLOR = 'black';

    var BASE_CHART_OPTS = 'izendaSimpleGauge';
    var IZENDA_CHART = 'izendaKPIMetric';

    var defaultPlotOptions = H.getOptions().plotOptions,
      baseChart = H.seriesTypes[BASE_CHART_OPTS],
      each = H.each;

    defaultPlotOptions[IZENDA_CHART] = H.merge(defaultPlotOptions[BASE_CHART_OPTS], {});

    H.seriesTypes[IZENDA_CHART] = H.extendClass(baseChart, {
      type: IZENDA_CHART,

      padding: 10,

      /**
       * @method drawPoint
       * @description draws kpi data point and positions it within the tile area
       */
      drawPoint: function(container, pointData) {
        var series = this;
        var chart = series.chart;
        var options = chart.options;
        var plotBox = chart.plotBox;
        var textColor = pointData.textColor || TEXT_COLOR;

        var primaryContainer = chart.renderer.g('primary-kpi').add(container);
        this.drawPrimaryKPI(primaryContainer, pointData, textColor);

        this.adjustPosition(
          ((plotBox.width - primaryContainer.getBBox().width) / 2 ),
          (chart.containerHeight - primaryContainer.getBBox().height) / 2 - primaryContainer.getBBox().y,
          primaryContainer
        );

        // attack click event
        var onClick = get('chart.events.click', options);

        if (onClick) {
          container.element &&
            $izenda(container.element)
              .css({ cursor: 'pointer' })
              .on('click', onClick);
        }
      },

      findFontSize: function () {
        var chart = this.chart;
        var basedFontSize = 0;
        var pointData = chart.options.series[0].data[0];
        var tempString = this.getFormattedData(pointData.y, pointData);

        do {
          basedFontSize++;
          var stringGraphic = chart.renderer
            .text(tempString)
            .css({
              ...chart.renderer.style,
              fontSize: basedFontSize + 'px'
            })
            .add();
          var stringGraphicBBox = stringGraphic.getBBox();
          stringGraphic.destroy();
        } while (
          stringGraphicBBox.width < chart.chartWidth - this.padding &&
          stringGraphicBBox.height < chart.chartHeight
        );
        return basedFontSize;
      },

      render: function () {
        var series = this;
        var chart = series.chart;
        var data = get('series[0].data[0]', chart.options);
        var graphic;

        var basedInfo = caculateBasedSize.call(this, chart);

        this.basedFontSize = basedInfo.basedFontSize;
        this.maxChars = basedInfo.maxChars;

        // draw point
        each(
          series.points,
          function (point) {
            graphic = point.graphic;

            if (graphic) {
              return;
            }

            point.graphic = chart.renderer.g('simple-gauge').add(chart.seriesGroup);
            this.drawPoint(point.graphic, data);
          }.bind(this)
        );

        function caculateBasedSize() {
          var basedFontSize, maxChars;


          maxChars = MAX_CHARS;
          basedFontSize = this.findFontSize(maxChars);

          return {
            basedFontSize: basedFontSize,
            maxChars: maxChars
          };
        }
      }
    });
  };
})();



// WEBPACK FOOTER //
// ./ui/share/components/charting/highcharts/Izenda.KPIMetric.js